"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
//
const IPOCPage_1 = __importDefault(require("./routes/IPOCPage"));
const Dashboard_1 = __importDefault(require("./routes/Dashboard"));
const ExercisesList_1 = require("./routes/ExercisesList");
const Landing_1 = require("./routes/Landing");
const SpeechDevelopment_1 = __importDefault(require("@app/routes/SpeechDevelopment"));
const SyllabicStructure_1 = __importDefault(require("@app/routes/SyllabicStructure"));
const pageMap = {
    charts: react_1.default.createElement(Dashboard_1.default, null),
    ipoc: react_1.default.createElement(IPOCPage_1.default, null),
    landing: react_1.default.createElement(Landing_1.Landing, null),
    "exercises-list": react_1.default.createElement(ExercisesList_1.ExercisesList, null),
    "speechDevelopment": react_1.default.createElement(SpeechDevelopment_1.default, null),
    "syllable_structure": react_1.default.createElement(SyllabicStructure_1.default, null),
};
const App = () => {
    const path = localStorage.getItem("reactRote");
    return react_1.default.createElement("div", { id: "react-app", style: { width: '100%', height: '100%' } }, pageMap[path]);
};
exports.default = App;
